// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__ZtkmQ","content__ttl":"styles_content__ttl__kerjJ","content__txt":"styles_content__txt__jXfD2","img":"styles_img__RQ2lC"};